import React, { useState, useEffect } from "react";
// import MapModal from './Map'; // 제거

function RouteTab({ routeList, onDeleteRoute, labels, colors, onLabelChange, onColorChange, checkedList, setCheckedList, handleCheck, showAllMarkers, onShowOnMap, onReorderRoutes }) {
  // 20241028.json 데이터
  const [busStopData, setBusStopData] = useState([]);
  // (checkedList 상태는 상위에서 관리)
  // mapModalOpen, mapModalRoute 등 지도 모달 관련 상태 모두 제거
  const [editingIdx, setEditingIdx] = useState(null);
  const [editText, setEditText] = useState('');
  
  // 드래그 앤 드롭 관련 상태
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  // 드래그 시작 핸들러
  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', index);
  };

  // 드래그 오버 핸들러
  const handleDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setDragOverIndex(index);
  };

  // 드래그 엔터 핸들러
  const handleDragEnter = (e, index) => {
    e.preventDefault();
    setDragOverIndex(index);
  };

  // 드래그 리브 핸들러
  const handleDragLeave = (e) => {
    setDragOverIndex(null);
  };

  // 드롭 핸들러
  const handleDrop = (e, index) => {
    e.preventDefault();
    if (draggedIndex !== null && draggedIndex !== index && onReorderRoutes) {
      onReorderRoutes(draggedIndex, index);
    }
    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  // 드래그 엔드 핸들러
  const handleDragEnd = () => {
    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  // 체크된 항목 삭제
  const handleDeleteChecked = () => {
    if (window.confirm('선택한 항목을 삭제하겠습니까?')) {
      // 체크된 항목의 인덱스를 뒤에서부터 삭제
      for (let idx = checkedList.length - 1; idx >= 0; idx--) {
        if (checkedList[idx]) {
          onDeleteRoute(idx);
        }
      }
    }
  };

  // 20241028.json 불러오기
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/20241028.json")
      .then(res => res.json())
      .then(data => {
        setBusStopData(data);
      })
      .catch(err => {
        console.error("정류장 데이터 불러오기 실패:", err);
      });
  }, []);

  // 노선명 기본 색상 규칙 (모든 노선을 초록색으로)


  // 승하차지 도시명으로 지역명 생성


  // 메모 관련 상태, 함수, UI 모두 삭제

  return (
    <div style={{ padding: 16 }}>
      <h2>노선 정보 목록</h2>
      {/* 노선도 그리기 버튼 추가 */}
      <button
        onClick={() => {
          if (!routeList || routeList.length === 0) {
            alert('검색된 노선이 없습니다.');
          } else {
            // 체크된 항목만 전달
            if (typeof window.handleDrawAllRoutes === 'function') {
              window.handleDrawAllRoutes();
            }
          }
        }}
        style={{
          marginBottom: 16,
          padding: '8px 16px',
          fontSize: 16,
          background: '#3498db',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          cursor: 'pointer',
          fontWeight: 'bold',
          marginRight: 8
        }}
      >
        노선 그룹화
      </button>

      <button
        onClick={() => {
          // 전체선택/전체해제: 모두 true면 전체해제, 아니면 전체선택
          const allChecked = checkedList.length > 0 && checkedList.every(Boolean);
          setCheckedList(Array(routeList.length).fill(!allChecked));
        }}
        style={{
          marginBottom: 16,
          padding: '8px 16px',
          fontSize: 16,
          background: '#27ae60',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          cursor: 'pointer',
          fontWeight: 'bold',
          marginRight: 8
        }}
      >
        {checkedList.length > 0 && checkedList.every(Boolean) ? '전체해제' : '전체선택'}
      </button>

      <button
        onClick={handleDeleteChecked}
        style={{
          marginBottom: 16,
          padding: '8px 16px',
          fontSize: 16,
          background: '#e74c3c',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        삭제
      </button>

      {routeList.length > 0 ? (
        <div>
          {/* 드래그 앤 드롭 안내 메시지 */}
          <div style={{
            marginBottom: 12,
            padding: '8px 12px',
            background: '#e8f4fd',
            border: '1px solid #3498db',
            borderRadius: 6,
            fontSize: 14,
            color: '#2980b9',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}>
            <span style={{ fontSize: 16 }}>↕️</span>
            <span>그룹화 시 최하단 노선이 시작점입니다.</span>
          </div>
          
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            maxHeight: '50vh',
            overflowY: 'scroll',
            border: '1px solid #eee',
            borderRadius: 8,
            padding: 4,
            background: '#fafbfc',
            scrollbarWidth: 'thin',
            scrollbarColor: '#bbb #fafbfc'
          }}>
            {routeList.map((info, idx) => {
              const isEditing = editingIdx === idx;
              const isDragging = draggedIndex === idx;
              const isDragOver = dragOverIndex === idx;
              
              return (
                <div 
                  key={idx} 
                  draggable={true}
                  onDragStart={(e) => handleDragStart(e, idx)}
                  onDragOver={(e) => handleDragOver(e, idx)}
                  onDragEnter={(e) => handleDragEnter(e, idx)}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleDrop(e, idx)}
                  onDragEnd={handleDragEnd}
                  style={{ 
                    position: 'relative', 
                    background: isDragging ? '#e8f4fd' : isDragOver ? '#f0f8ff' : '#f8f8f8', 
                    padding: 16, 
                    borderRadius: 8, 
                    boxShadow: isDragging ? '0 4px 12px rgba(0,0,0,0.15)' : '0 2px 8px rgba(0,0,0,0.04)', 
                    cursor: isDragging ? 'grabbing' : 'grab',
                    opacity: isDragging ? 0.8 : 1,
                    transform: isDragging ? 'rotate(2deg)' : 'none',
                    transition: 'all 0.2s ease',
                    border: isDragOver ? '2px dashed #3498db' : '1px solid transparent',
                    marginBottom: isDragOver ? 8 : 0
                  }}
                  onClick={() => {
                    if (!isEditing) {
                      setEditingIdx(idx);
                      setEditText(info.label || '');
                    }
                  }}
                >
                  {/* 드래그 핸들 아이콘 */}
                  <div 
                    style={{
                      position: 'absolute',
                      left: 8,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontSize: 20,
                      color: '#999',
                      cursor: 'grab',
                      userSelect: 'none',
                      zIndex: 1
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                  >
                    ⋮⋮
                  </div>
                  
                  {/* 체크박스 */}
                  <input
                    type="checkbox"
                    checked={!!checkedList[idx]}
                    onClick={e => e.stopPropagation()}
                    onChange={e => { e.stopPropagation(); handleCheck(idx); }}
                    style={{ position: 'absolute', right: 25, top: 15, width: 28, height: 28 }}
                    title="선택"
                  />
                  {/* 지도(🌍) 버튼 */}
                  <button
                    onClick={e => { e.stopPropagation(); onShowOnMap && onShowOnMap(info, null, info.routeName); }}
                    style={{
                      position: 'absolute', right: 40, top: 60, width: 28, height: 28,
                      background: 'none', border: 'none', fontSize: 30, cursor: 'pointer', lineHeight: 1
                    }}
                    title="지도에서 보기"
                  >🗺️</button>
                  {/* 삭제 버튼 제거 */}
                  <div style={{ marginBottom: 8, fontSize: 17, fontWeight: 'bold', color: '#000', marginRight: 40, marginLeft: 30, userSelect: 'none' }} onContextMenu={e => e.preventDefault()}>
                    {info.routeName}
                    {info.routeType && (
                      <span style={{ marginLeft: 8, fontSize: 14, color: '#e74c3c', fontWeight: 'normal', userSelect: 'none' }} onContextMenu={e => e.preventDefault()}>
                        [{info.routeType}]
                      </span>
                    )}
                  </div>
                  <div style={{ marginBottom: 4, fontSize: 15, color: '#222', marginRight: 40, marginLeft: 30, userSelect: 'none' }} onContextMenu={e => e.preventDefault()}>
                    {info.boarding?.name} ▷ {info.alighting?.name}
                  </div>

                  {/* info.label 표시 */}
                  <div style={{ marginTop: 12, marginLeft: 30 }}>
                    <div style={{ fontSize: 15, color: info.label ? '#222' : '#bbb', minHeight: 22, whiteSpace: 'pre-line', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical' }}>
                      {info.label
                        ? (info.label.split('\n').length > 1
                            ? info.label.split('\n').slice(0,2).join('\n') + '...'
                            : info.label)
                        : '메모 없음 (클릭하여 입력)'}
                    </div>
                  </div>
                  {/* 모달 메모창 */}
                  {isEditing && (
                    <>
                      {/* 배경 오버레이 */}
                      <div 
                        style={{ 
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          width: '100vw',
                          height: '100vh',
                          background: 'rgba(0,0,0,0.5)',
                          zIndex: 999
                        }}
                        onClick={() => setEditingIdx(null)}
                      />
                      {/* 모달 창 */}
                      <div style={{ 
                        position: 'fixed',
                        top: '30%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        background: '#fff',
                        border: '2px solid #3498db',
                        borderRadius: 12,
                        padding: 24,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                        zIndex: 1000
                      }}>
                        <div style={{ marginBottom: 8, fontSize: 18, fontWeight: 'bold', color: '#000000', textAlign: 'center' }}>
                          {info.routeName}
                        </div>

                        <textarea
                          value={editText}
                          onChange={e => setEditText(e.target.value)}
                          style={{
                            width: '95%',
                            height: '30vh',
                            fontSize: 16,
                            border: '1px solid #ddd',
                            borderRadius: 8,
                            padding: 12,
                            resize: 'none',
                            fontFamily: 'inherit'
                          }}
                          placeholder="'//'전후로 승하차 메모 구분"
                          autoFocus
                        />
                        <div style={{ 
                          display: 'flex', 
                          gap: 12, 
                          justifyContent: 'center',
                          marginTop: 16
                        }}>
                          <button
                            onClick={() => { onLabelChange && onLabelChange(idx, editText); setEditingIdx(null); }}
                            style={{
                              padding: '12px 24px',
                              fontSize: 16,
                              background: '#27ae60',
                              color: '#fff',
                              border: 'none',
                              borderRadius: 8,
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              minWidth: 80
                            }}
                          >
                            확인
                          </button>
                          <button
                            onClick={() => setEditingIdx(null)}
                            style={{
                              padding: '12px 24px',
                              fontSize: 16,
                              background: '#e74c3c',
                              color: '#fff',
                              border: 'none',
                              borderRadius: 8,
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              minWidth: 80
                            }}
                          >
                            취소
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div>노선을 검색해 지정하세요.</div>
      )}
      {/* 메모 입력 모달만 남기고, MapModal 모달 완전히 제거 */}
    </div>
  );
}

export default RouteTab;
